<template>
  <v-snackbar
    v-model="snackbar"
    right
    top
    :color="color"
    class="snackbar"
    vertical
  >
    <div v-if="title">
      <h3 :class="color">{{ title }}</h3>
    </div>

    <div
      v-for="message in messages"
      :key="message"
      class="text"
      :class="color"
    >
      {{ message }}
    </div>

    <template v-slot:action="{ attrs }">
      <v-btn
        :class="color"
        v-bind="attrs"
        text
        @click="closeSnackbar"
      >
        Fechar
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { mapState } from 'vuex';
import { updateVisibility } from '@/store/modules/snackbar/actions';
export default {
  name: 'Snackbar',
  data() {
    return {
      types: ['info', 'error', 'warning', 'success'],
    };
  },
  computed: {
    ...mapState({
      isVisible: (state) => state.snackbar.isVisible,
      messages: (state) => state.snackbar.messages,
      type: (state) => state.snackbar.type,
      title: (state) => state.snackbar.title,
    }),

    snackbar: {
      get() {
        return this.isVisible;
      },
      set(value) {
        this.$store.dispatch(updateVisibility, value);
      },
    },
    color() {
      return this.types.includes(this.type) ? this.type : 'info';
    },
  },
  methods: {
    closeSnackbar() {
      this.$store.dispatch(updateVisibility, false);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/snackbar.scss';
</style>
